import React from 'react';

export default function OperationStatus({ active = false, title = 'Processando...', steps = [], tone = 'info' }) {
  if (!active) return null;

  const visibleSteps = steps.filter(Boolean);

  return (
    <div className={`operation-status operation-status--${tone}`} role="status" aria-live="polite">
      <div className="operation-status__header">
        <strong>{title}</strong>
        <span>Aguarde</span>
      </div>
      <div className="operation-status__bar" aria-hidden="true">
        <span />
      </div>
      {!!visibleSteps.length && (
        <ol className="operation-status__log">
          {visibleSteps.map((step, index) => (
            <li key={`${step}-${index}`}>{step}</li>
          ))}
        </ol>
      )}
    </div>
  );
}
